<template>
  <div class="mvt-cardproperty-info">
    <div>
      <a :href="cardHref" target="_blank" @click.stop="onclick" tabindex="-1">
        <address>
          <span>{{ property.geo.address }}{{ splitAddress ? " " : ", " }}</span><span>{{ getSubAddress }}</span>
        </address>
      </a>
      <img
          v-if="property.mlsLogoSrc && shouldShowMLSLogo"
          loading="lazy"
          class="img-mls"
          :alt="property.mlsDescription"
          :src="property.mlsLogoSrc"
      />
    </div>
    <ul :data-viewed="isViewed"  @click="onclick">
      <li class="price">
        {{ $filters.formatPrice(property.price) }}<abbr class="f5" title="Monthly Rent" v-if="property.isRentals">/Mo</abbr><abbr title="Estimate Value" v-if="property.isEstPrice">Est.</abbr>
      </li>
      <template v-if="!property.isLand">
        <li>
          {{ property.bed || '—' }}<abbr title="Bedroom">Bd</abbr>
        </li>
        <li>
          {{ property.bath || '—' }}<abbr title="Bathroom">Ba</abbr>
        </li>
      </template>
      <li v-if="property.area">
        {{ $filters.formatArea(property.area, property.isLand) }}
        <abbr :title="property.areaUnit">{{property.isLand ? 'Acre' : 'Sq Ft'}}</abbr>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'PropertyCardInfo',
  props: {
    property: Object,
    cardHref: String,
    splitAddress: {
        type: Boolean,
        default: false,
    }
  },
  methods: {
    ...mapGetters('glb', ['getComplianceMethod']),
    shouldShowMLSLogo() {
      const compliance = this.getComplianceMethod()();
      return compliance[0]?.rule.indexOf('hidePropertyCardLogo') === -1;
    },
    onclick(e){
      e.preventDefault();
      this.$emit('openDpp');
    }
  },
  computed: {
    ...mapGetters('glb', ['viewedListings']),
    getSubAddress() {
      const { city, state, zipcode } = this.property.geo;
      return `${city}, ${state} ${zipcode}`;
    },
    isViewed() {
      return this.property && !this.property.hideIsViewed && this.viewedListings.includes(this.property.propertyId);
    },
  },
};
</script>
